import React from "react";
import { frameSettings } from "shared/utils/doorConfigurations";
import { useConfigurationOptionsContext } from "../../../../../../../app/providers/DoorOptionsProvider";
import {
  DoorGlassMaterial,
  getDoubleFramePositions,
  getFrameScaling,
} from "../../../../../../../shared/utils/door";
import { getFullAssetPath } from "shared/utils/assets";
import { useGLTF } from "@react-three/drei";
import { SilverHandlesGLTFResult } from "../../enkel/handlesType";

interface FramePassiveProps extends frameSettings {
  doorNodes: any;
  materials: DoorGlassMaterial;
  index: number;
}

const FramePassive: React.FC<FramePassiveProps> = ({
  doorNodes,
  materials,
  index,
  ...frameSettings
}: FramePassiveProps) => {
  const {
    getConfigurationHeight,
    getConfigurationWidth,
    getConfigurationColor,
    handle,
  } = useConfigurationOptionsContext();

  const height = getConfigurationHeight(index);
  const width = getConfigurationWidth(index);

  const positions = getDoubleFramePositions(width, height, "right");
  const scaling = getFrameScaling(width, height);

  const yPositionSides = -0.01 * (-1 * (1 - scaling.vertical.y));

  const xHingePosition = -(
    positions.left.x +
    width / 1000 +
    880 / 1000 +
    0.035
  );

  const { materials: materialsHandle } = useGLTF(
    getFullAssetPath("/objects-v3/kaderdeurSilverHandles-v1.glb"),
  ) as SilverHandlesGLTFResult;

  // Determine hinge color based on handle type (zwart, rvsilver)
  const hingeColor = handle?.code.includes("zwart")
    ? materials["PoedercoatGitZwart"]
    : materialsHandle.MergedBake_Baked;

  return (
    <group dispose={null}>
      <mesh
        geometry={doorNodes["frame_top_passive"].geometry}
        material={materials[getConfigurationColor()]}
        scale={scaling.horizontal}
        position={[
          positions.top.x + 0.025,
          positions.top.y - 0.002,
          positions.top.z,
        ]}
      ></mesh>
      <mesh
        geometry={doorNodes["frame_bottom_passive"].geometry}
        material={materials[getConfigurationColor()]}
        scale={scaling.horizontal}
        position={[
          positions.bottom.x + 0.025,
          positions.bottom.y,
          positions.bottom.z,
        ]}
      ></mesh>
      <mesh
        geometry={doorNodes["frame_left_passive"].geometry}
        material={materials[getConfigurationColor()]}
        scale={scaling.vertical}
        position={[positions.left.x, yPositionSides, 0]}
      ></mesh>
      <mesh
        geometry={doorNodes["frame_right_passive"].geometry}
        material={materials[getConfigurationColor()]}
        scale={scaling.vertical}
        position={[positions.right.x, yPositionSides, 0]}
      ></mesh>
      <group>
        <mesh
          geometry={doorNodes["hinge_2_passive"].geometry}
          rotation={[0, 0, 0]}
          material={hingeColor}
          position={[
            xHingePosition,
            positions.top.y + (frameSettings?.frameTop?.shiftY ?? 0),
            0,
          ]}
        ></mesh>
        <mesh
          geometry={doorNodes["hinge_1_passive"].geometry}
          rotation={[0, 0, 0]}
          material={hingeColor}
          position={[
            xHingePosition,
            positions.top.y + (frameSettings?.frameTop?.shiftY ?? 0),
            0,
          ]}
        ></mesh>
        <mesh
          geometry={doorNodes["hinge_0_passive"].geometry}
          rotation={[0, 0, 0]}
          material={hingeColor}
          position={[xHingePosition, positions.bottom.y, 0]}
        ></mesh>
      </group>
    </group>
  );
};

export default FramePassive;
